import { Link, Outlet } from 'react-router-dom';
import classes from './loan-report-master-page.module.css';

export interface LoanReportMasterPageProps { }

function LoanReportMasterPage(props: LoanReportMasterPageProps) {

	return (
		<div className='row'>
			<div className='col-3'>
				<div className="section section-primary">
					<div className='list-group'>
						<Link to={"summary"} className='list-group-item'>Loan Summary</Link>
						<Link to={"disabled"} className='list-group-item'>Loan Disabled</Link>
						<Link to={"portfolio"} className='list-group-item'>Loan Portfolio</Link>
					</div>
				</div>
			</div>
			<div className="col-9">
				<Outlet />
			</div>
		</div>
	);
}

export default LoanReportMasterPage;